<template>
  <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke-width="2" stroke-miterlimit="10"/>
  <path d="M12 6.75V12H17.25" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</template>
